import * as React from 'react';
import React__default, { useState, useEffect } from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import { getNiceName, getLanguage } from '@ta-interaktiv/api-access';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".CopyrightNotice-module_copyrightNotice__XIfqH{text-align:center;display:block}.CopyrightNotice-module_logo__QSd85{width:2rem;height:auto;margin:0 auto}.CopyrightNotice-module_logo__QSd85,.CopyrightNotice-module_logo__QSd85 img{display:block}.CopyrightNotice-module_linkList__jrEVw{font-size:.75rem;color:var(--muted-text-color);font-family:var(--ui-font-stack);line-height:1.75ex;margin-top:1ex}.CopyrightNotice-module_linkList__jrEVw .CopyrightNotice-module_item__vqk7X{display:inline-block}.CopyrightNotice-module_linkList__jrEVw .CopyrightNotice-module_item__vqk7X+.CopyrightNotice-module_item__vqk7X{padding-left:1ch;margin-left:1ch;border-left:1px solid var(--light-text-color)}.CopyrightNotice-module_linkList__jrEVw a[href]{color:var(--light-text-color)}.CopyrightNotice-module_linkList__jrEVw a[href]:hover{color:var(--muted-text-color)}";
var styles = {"copyrightNotice":"CopyrightNotice-module_copyrightNotice__XIfqH","logo":"CopyrightNotice-module_logo__QSd85","linkList":"CopyrightNotice-module_linkList__jrEVw","item":"CopyrightNotice-module_item__vqk7X"};
styleInject(css_248z);

var data = { de:{ privacyPolicy:"Datenschutz" },
  fr:{ privacyPolicy:"Déclaration de confidentialité" },
  en:{ privacyPolicy:"Privacy Policy" } };

function PureCopyrightNotice(_a) {
    var _b = _a.inverted, inverted = _b === void 0 ? false : _b, fullMediaName = _a.fullMediaName, mediaName = _a.mediaName, _c = _a.year, year = _c === void 0 ? new Date(Date.now()).getFullYear() : _c, _d = _a.displayPrivacyPolicyLink, displayPrivacyPolicyLink = _d === void 0 ? true : _d, _e = _a.locale, locale = _e === void 0 ? 'de' : _e;
    if (!mediaName) {
        return null;
    }
    return (React.createElement("div", { className: "copyright-notice " + styles.copyrightNotice + " " + (inverted ? 'inverted' : '') },
        React.createElement("a", { href: "https://www." + mediaName + ".ch/", className: styles.logo },
            React.createElement("img", { src: "https://interaktiv.tagesanzeiger.ch/static/icons/" + mediaName + (inverted ? '-inverted' : '') + ".svg", alt: '' })),
        React.createElement("div", { className: styles.linkList },
            React.createElement("a", { href: "https://www." + mediaName + ".ch/", className: styles.item },
                "\u00A9 ",
                year,
                " ",
                fullMediaName),
            displayPrivacyPolicyLink && (React.createElement("a", { href: "https://abo." + mediaName + ".ch/tamstorefront/terms/register", className: styles.item }, data[locale].privacyPolicy)))));
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function PolymorphicCopyrightNotice(props) {
    var _a = useState({}), downloadedData = _a[0], setData = _a[1];
    useEffect(function () {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            console.group('Polymorphic Copyright Notice');
            console.log('In development mode.');
            console.groupEnd();
            setData({
                fullMediaName: 'Local Host',
                mediaName: 'localhost'
            });
            return;
        }
        if (props.mediaName && props.fullMediaName) {
            return;
        }
        var secondLevelDomainName = props.mediaName || parseHostname().publicationName;
        Promise.all([
            getNiceName(secondLevelDomainName),
            getLanguage(secondLevelDomainName)
        ])
            .then(function (_a) {
            var fullMediaName = _a[0], language = _a[1];
            setData({
                mediaName: secondLevelDomainName,
                fullMediaName: props.fullMediaName || fullMediaName,
                locale: props.locale || language
            });
        })
            .catch(function (error) {
            console.group('Polymorphic Copyright Notice');
            console.warn('The endpoint could not be reached (or threw up for some other reason).');
            console.log(error.message, error);
            console.groupEnd();
            setData({
                mediaName: secondLevelDomainName
            });
        });
    }, [props.mediaName]);
    return React__default.createElement(PureCopyrightNotice, __assign({}, props, downloadedData));
}

export { PolymorphicCopyrightNotice as CopyrightNotice, PolymorphicCopyrightNotice, PureCopyrightNotice };
//# sourceMappingURL=index.m.js.map
